import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import CustomButton from "../CustomButton";
import { showToast } from "../../utils/toastUtils";
import { useFormik } from "formik";
import ShortTextInput from "../Inputs/ShortTextInput";
import { addNoteToProject, addNoteToWorkStream, updateProjectNote, updateWorkStreamNote } from "../../api/Api";
import ModalUI from "../ui/ModalUI";
import TextAreaInput from "../Inputs/TextAreaInput";
import { noteValidationSchema } from "../../utils/validations";

// isEdit only use for when use as edit note
// note is the note object to edit
// example of note object
// {
//     "id": 1,
//     "title": "Note title",
//     "note": "Note description",
// }
function AddNote({
  show,
  handleClose,
  workStream_id,
  project_id,
  refresh,
  isEdit,
  setIsEdit,
  note,
  entity_type,// workStream or project
}) {
    const [loading, setLoading] = useState(false);
  
    const formik = useFormik({
      initialValues: {
        title: note?.title || "",
        note: note?.note || "",
      },
      enableReinitialize: true,
      validationSchema: noteValidationSchema,
      onSubmit: async (values) => {
        console.log(values);
        setLoading(true);
  
        try {
          let response;
          if (isEdit) {
            // Update note
            entity_type === "workStream" 
            ? response = await updateWorkStreamNote(workStream_id, note.id, values)
            : response = await updateProjectNote(project_id, note.id, values);

            if (response.status === 200) {
              showToast("Note updated successfully", "success")} 
            else {
              showToast(response.data.message, "error");
              console.error("Error updating note:", response);
            }
          } else {
            // Add new note
            entity_type === "workStream"
            ? response = await addNoteToWorkStream(workStream_id, values)
            : response = await addNoteToProject(project_id, values);
            
            if (response.status === 200) {
              showToast("Note added successfully", "success");
            } else {
              showToast(response.data.message, "error");
              console.error("Error adding note:", response);
            }
          }
  
  
        } catch (error) {
          showToast(`Error ${isEdit ? "updating" : "adding"} note`, "error");
          console.error(`Error ${isEdit ? "updating" : "adding"} note:`, error);
        } finally {
          setLoading(false);
          refresh(workStream_id);
          if (isEdit) setIsEdit(false);
          formik.resetForm();
          handleClose();
        }
      },
    });

    
  return (
    <AddNoteUI
      show={show}
      handleClose={handleClose}
      isEdit={isEdit}
      formik={formik}
      loading={loading}
    />
  );
}

export default AddNote;

// AddNoteUI component
// This component is separated from AddNote component to make it more readable and maintainable
// This component is used for UI only
export const AddNoteUI = ({ show, handleClose, isEdit,formik, loading }) => {
  return (
    <ModalUI show={show} handleClose={handleClose} title={isEdit ? "Edit Note" : "Add Note"}>
      <Modal.Body style={{padding: 0 }}>
        <form onSubmit={formik.handleSubmit}>
          <ShortTextInput
            label="Title"
            id="title"
            value={formik.values.title}
            onChange={formik.handleChange}
            error={formik.touched.title && formik.errors.title ? formik.errors.title : ""}
          />
          <TextAreaInput 
            label="Note"
            id="note"
            value={formik.values.note}
            onChange={formik.handleChange}
            error={formik.touched.note && formik.errors.note ? formik.errors.note : ""}
          />
        </form>
      </Modal.Body>
      <Modal.Footer
        className="justify-content-center border-0"
      >
        <CustomButton type="submit" onClick={formik.handleSubmit}>
          {loading ? "Saving..." : isEdit ? "Update" : "Add Note"}
        </CustomButton>
      </Modal.Footer>
    </ModalUI>
  );
}

